import Close from '@mui/icons-material/Close'
import React, { useCallback } from 'react'

import { COLORS, styled } from '../../../../../theme'
import { ButtonIcon, ButtonPrimary, ButtonSecondary } from '../../../../Button'
import { Dialog } from '../../../../Dialog'
import { Typography } from '../../../../Typography'
import { FormFooterWrapper, FormHeaderWrapper, FormWrapper } from '../../../Form'

const StyledFormHeaderWrapper = styled(FormHeaderWrapper)`
  background-color: ${COLORS.grey50};
  padding: 16px 24px;
`
const StyledFormWrapper = styled(FormWrapper)`
  padding: 24px;
  border-top: 1px solid ${COLORS.divider};
  border-bottom: 1px solid ${COLORS.divider};
  align-items: stretch;
  gap: 10px;
  min-width: 440px;
`
const DeleteButtonStyled = styled(ButtonPrimary)`
  background-color: ${COLORS.error.main};
  color: white;

  &:hover {
    background-color: ${COLORS.error.dark};
  }

  margin-right: 5px;
`

interface DeleteTherapyModalProps {
  title: string
  deleteModalOpen: boolean
  handleCloseDeleteElementModal: (save?: boolean) => void
}
// eslint-disable-next-line import/no-unused-modules
export const DeleteRowModal = ({ title, deleteModalOpen, handleCloseDeleteElementModal }: DeleteTherapyModalProps) => {
  const handleClose = useCallback(
    (save?: boolean) => {
      if (handleCloseDeleteElementModal) {
        handleCloseDeleteElementModal(save)
      }
    },
    [handleCloseDeleteElementModal],
  )

  return (
    <Dialog
      open={deleteModalOpen}
      onClose={() => {
        handleClose()
      }}
    >
      <StyledFormHeaderWrapper>
        <Typography data-test-id="action-row-modal-title-delete" variant="h6">
          {title}
        </Typography>
        <ButtonIcon data-test-id="button-close_delete_row_modal" onClick={() => handleClose()}>
          <Close />
        </ButtonIcon>
      </StyledFormHeaderWrapper>
      <StyledFormWrapper>
        <Typography variant="body1">
          Are you sure? <br />
          <br /> You want to delete this therapy?
        </Typography>
      </StyledFormWrapper>
      <FormFooterWrapper>
        <ButtonSecondary data-test-id="delete_row_data_modal-cancel_button" onClick={() => handleClose()}>
          Cancel
        </ButtonSecondary>
        <DeleteButtonStyled data-test-id="delete_row_data_modal-delete_button" onClick={() => handleClose(true)}>
          Delete
        </DeleteButtonStyled>
      </FormFooterWrapper>
    </Dialog>
  )
}
